import { render, staticRenderFns } from "./freeElectricBindDialog.vue?vue&type=template&id=3cb1f266&"
import script from "./freeElectricBindDialog.vue?vue&type=script&lang=js&"
export * from "./freeElectricBindDialog.vue?vue&type=script&lang=js&"
import style0 from "./freeElectricBindDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports